<template>
  <div>
    <configuration-order-summary v-if="ADDRESS.funnel_v2"/>
    <checkout-summary-default v-else/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CheckoutSummaryDefault from "@/views/checkout/CheckoutSummaryDefault.vue";
import ConfigurationOrderSummary from "@/views/checkout/configuration/ConfigurationOrderSummary.vue";

export default {
  name: "CheckoutSummary",
  components: {
    CheckoutSummaryDefault,
    ConfigurationOrderSummary
  },
  computed: {
    ...mapGetters(['ADDRESS']),
  },
}
</script>
